import { render, staticRenderFns } from "./October_2022.vue?vue&type=template&id=02dc79fc&scoped=true&"
import script from "./October_2022.vue?vue&type=script&lang=js&"
export * from "./October_2022.vue?vue&type=script&lang=js&"
import style0 from "./October_2022.vue?vue&type=style&index=0&id=02dc79fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc79fc",
  null
  
)

export default component.exports